import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { NavigationService } from '../../core/navigation.service';
import { ProgressBarService } from '../../core/progress-bar.service';
import { StoreService } from '../../core/store.service';
import { SchoolSystem } from '../../models/state.model';

@Component({
  selector: 'welcome',
  templateUrl: './welcome.component.html',
})
export class WelcomeComponent {
  title = 'welcome-jcps.title';
  isJcpsSchoolSystem: boolean = this.store.state.schoolSystem == SchoolSystem.Jcps;

  constructor(private router: Router,
    private store: StoreService,
    private progress: ProgressBarService,
    private navigation: NavigationService) {
  }

  next(isStaff: boolean) {
    this.progress.set(isStaff);

    this.store.state.isStaff = isStaff;
    this.navigation.setButtons(isStaff);

    this.router.navigate([this.navigation.welcome.next]);
  }

}
